import { useChannel } from "./ws/useChannel";
import useQuery, { useRevalidate } from "./useQuery";
import { useUser } from "./useUser";
import useDebouncedCallback from "@ui/lib/hooks/useDebouncedCallback";

function useFavoriteProjectIds() {
  const revalidate = useRevalidate();
  const user = useUser();
  const callback = useDebouncedCallback(
    () => {
      void revalidate("/users/favorites/projects");
    },
    [revalidate],
    2_000,
    {
      leading: true,
      maxWait: 2_000,
      trailing: true,
    },
  );

  useChannel({ key: "favorites", userId: String(user.id) }, callback, true);

  return useQuery("/users/favorites/projects", {}).body;
}

export default useFavoriteProjectIds;
